import React, { useEffect, useState } from "react";
import { MDBTable, MDBTableBody, MDBTableHead } from "mdbreact";
// import { QRCodeSVG } from 'qrcode.react';
import { useUserContext } from "../../../context/user_context";
import { useParams } from "react-router-dom";
import { useSalesContext } from "../../../context/sales_context";
import { logo_main } from "../../../assets";
import { Button } from "../../../styles";
import { ICON_RECEIPT } from "../../../utils/icons";
import { th } from "../../../utils/helpers";
import { naira } from "../../../utils/data";
import styled from "styled-components";

const PrintInvoice = (props) => {


    const { businessData, storeData } = useUserContext();

    const params = useParams();


    const { id: invid } = params;

    const {
        salesItemLoading, salesItem, getSalesItem,
    } = useSalesContext();

    const {
        details,
        sales_items,
        customer_name,
        customer_mail,
        customer_phone,
        sales_date,
        total_amount_th,
        total_amount,
        taxVatData,
        userData
    } = {} = salesItem;

    useEffect(() => {
        getSalesItem(invid);
    }, []);


    const invoiceDetails = [
        { title: 'Invoice ID', content: invid },
        { title: 'Date', content: sales_date },
        { title: 'Attendant', content: userData?.fullname || 'Nil' },

    ];
    const customerDetails = [
        { title: 'Customer\'s Name', content: customer_name },
        { title: 'Customer\'s Phone', content: customer_phone },
        { title: 'Customer\'s Email', content: customer_mail },
    ];


    return (
        <StyledPrintInvoice>
            <div className="white pt-5 ">
                <div className="px-4 border">

                    {/* Title */}

                    <div className="">
                        <div className="row border-bottom py-3 mb-4 align-items-center">
                            <div className="col pry-text ">
                                <h5 className=""> INVOICE
                                </h5>
                            </div>
                            <div className="col mx-auto">
                                <div className="text-end">
                                    <img src={businessData?.logo || logo_main} width="50px" alt="logo" />
                                </div>
                            </div>
                        </div>
                    </div>


                    {salesItemLoading ?
                        <div className="min-height-lg py-5 text-center">
                            <h5 className="pry-text"> Loading... </h5>
                        </div>
                        :
                        <>

                            {/* Title */}

                            <div className=" mb-3 border-bottom pb-4 row justify-content-center">
                                <div className="pry-text text-uppercase text-center">
                                    <h4 className="m-0">
                                        {businessData.name || 'Nil'}
                                    </h4>
                                    <h5 className="m-0">
                                        {(storeData.storename || storeData.storename === '0') || 'Nil'}
                                    </h5>
                                    <h6 className="m-0 ">
                                        {(businessData.address || storeData.location === '0') || 'Nil'}
                                    </h6>
                                    <small className="m-0 ">
                                        {(businessData.phone || storeData.phone === '0') || 'Nil'}
                                    </small>
                                </div>
                            </div>

                            {/* Invoice Details */}
                            <div className="border-bottom mb-3 row">

                                <div className=" pry-bold-text col-sm-6 mb-4 border-right">
                                    <p className="">
                                        INVOICE DETAILS
                                    </p>
                                    {
                                        invoiceDetails?.map(({ title, content }, i) =>
                                            <div className="row justify-content-end" key={i}>
                                                <div className="col">
                                                    <h6 className="mb-1 fw-bold">{title}: </h6>
                                                </div>
                                                <div className="col-md-8 col-8">
                                                    <h6 className="mb-1 fw-bold"> {content || 'Nil'}</h6>
                                                </div>
                                            </div>
                                        )
                                    }
                                </div>
                                <div className=" pry-bold-text col-sm-6 mb-4">
                                    <p className="">
                                        CUSTOMER'S DETAILS
                                    </p>
                                    {
                                        customerDetails?.map(({ title, content }, i) =>
                                            <div className="row justify-content-end" key={i}>
                                                <div className="col">
                                                    <h6 className="mb-1 fw-bold">{title}: </h6>
                                                </div>
                                                <div className="col-md-8 col-8">
                                                    <h6 className="mb-1 fw-bold"> {content || 'Nil'}</h6>
                                                </div>
                                            </div>
                                        )
                                    }
                                </div>

                            </div>

                            {/* Invoice Details */}

                            {/* Item Details */}
                            <div className="">
                                <MDBTable small responsive bordered>
                                    <MDBTableHead >
                                        <tr>
                                            <th className="text-center">No</th>
                                            <th>Description</th>
                                            <th className="text-center">Qty</th>
                                            <th className=" pr-2">Price</th>
                                            <th className=" pr-2">Amount</th>
                                        </tr>
                                    </MDBTableHead>
                                    <MDBTableBody color="white" >
                                        {sales_items?.map((item, i) => (
                                            <tr key={i}>
                                                <td className="text-center">{i + 1}</td>
                                                <td className="pt-3-half">
                                                    {item.item_name}
                                                </td>
                                                <td className="text-center">
                                                    {item.qty}
                                                </td>
                                                <td className=" pr-2">
                                                    {naira}{th(item.price)}
                                                </td>
                                                <td className=" pr-2">
                                                    {naira}{th(item.amount)}
                                                </td>
                                            </tr>
                                        ))}
                                        <tr>
                                            <td className="text-center">=</td>
                                            <td className="pt-3-half">
                                                VAT ({businessData?.vat_rate || 0.00}%)
                                            </td>
                                            <td className="text-center">

                                            </td>
                                            <td className=" pr-2">

                                            </td>
                                            <td className=" pr-2">
                                                {naira}{taxVatData?.value || 0.00}
                                            </td>
                                        </tr>
                                    </MDBTableBody>
                                </MDBTable>

                                <h5 className="text-end mt-3 pry-bold-text border-bottom pb-2 "> TOTAL: <span className="">
                                    {naira}{taxVatData ?
                                        taxVatData?.vat_type === "inclusive" ?
                                            total_amount_th :
                                            th(Number(total_amount) + Number(taxVatData?.value))
                                        : total_amount_th
                                    }
                                </span>
                                </h5>

                            </div>
                            {details &&
                                <div className="row justify-content-end pry-text  ">
                                    <div className="col">
                                        <h5 className="mb-1 fw-light h6"> Description:</h5>
                                    </div>
                                    <div className="col-12 col-md-10 ">
                                        <h5 className="mb-1 fw-light h6 w-75 text-break"> {details}</h5>
                                    </div>
                                </div>
                            }

                            <div className="border-bottom container mt-5 pt-5">
                                {(businessData.accountnumber === '0' || businessData.accountnumber === '')
                                    ?
                                    <>
                                    </>
                                    :
                                    <>
                                        <h6 className="pry-bold-text font-weight-bold">
                                            Bank Details:  </h6>
                                        <ul>
                                            <li className="list-item">
                                                Bank Name: {businessData.bankname}
                                            </li>
                                            <li className="list-item">
                                                Account Name: {businessData.accountname}
                                            </li>
                                            <li className="list-item">
                                                Account Number: {businessData.accountnumber}
                                            </li>
                                        </ul>
                                    </>
                                }
                            </div>
                        </>
                    }
                </div>
            </div>
            <div className="my-4 d-flex justify-content-center w-100">
                <img src={logo_main} width="80px" alt="logo" />
            </div>
            <div className="text-center pb-4 light-bg container ">
                <Button
                    pry
                    className="btn m-0 w-lg-75 w-md-100"
                    onClick={() => window.frames['frame1'].print()}
                >
                    {ICON_RECEIPT} Print Receipt
                </Button>
            </div>

            {/* Invoice Reciept */}
            <div className="">
                <iframe src={`/user/invoice/${ invid }`} name="frame1" className="d-none w-100"></iframe>
            </div>
            {/* Invoice Reciept */}
            {/* Item Details */}

        </StyledPrintInvoice>
    );
};

export default PrintInvoice;


const StyledPrintInvoice = styled.main`

  padding-bottom: 5rem !important;


`;